import {DAMAGE_DICE_MAX_VALUE} from "../../configs/damage";

export const checkIfAlreadyBestResultForShootingD4 = (hasMoved, diceRoll1, diceRoll2) => {
  if (hasMoved) {
    return diceRoll1 >= DAMAGE_DICE_MAX_VALUE && diceRoll2 >= DAMAGE_DICE_MAX_VALUE;
  } else {
    return diceRoll1 >= DAMAGE_DICE_MAX_VALUE || diceRoll2 >= DAMAGE_DICE_MAX_VALUE;
  }
}